<div id="content">
     <section id="main" class="bg-light">
          <div id="csiContainer" class="container">
               <div class="row">
                    <div class="col-12">
                         <h1 [innerHtml]="'CSInfo' | translator: 'base'">Customer Service Information
                         </h1>
                         <p [innerHtml]="'CSInfoInfo' | translator: 'base'">
                              An error was encountered. Please contact the PSP Customer Support Team at <a
                                 alt="call customer service"
                                 href="tel:8776429499"
                                 name="1-877-642-9499">1-877-642-9499</a>
                              for information on completing this transaction. The PSP team is available by phone Monday
                              through Thursday from 8 AM to 6 PM ET, and on Friday from 8 AM to 5 PM ET.
                         </p>
                    </div>
               </div>
          </div>
     </section>
</div>